import { Usr } from '../usr';
import { CommonEnums } from '../../common.enums';


export class UsrsUtil {
    private static instance: UsrsUtil;

    static getInstance() {
        if (!UsrsUtil.instance) {
            UsrsUtil.instance = new UsrsUtil();
        }
        return UsrsUtil.instance;
    }

   /**
   * UsrsUtil is a singleton class, so use UsrsUtil.getInstance() method instead of creating new UsrsUtil().
   */
    private constructor() {

    }

    getPrimaryKey(usrs: Usr): string {
        return usrs.usr_Id + '' + usrs.usr_Id;
    }

    copy(usrsTmp: Array<Usr>): Array<Usr> {
        let usrs: Array<Usr> = new Array<Usr>();

        for (var i: number = 0; i < usrsTmp.length; i++) {
            let usr: Usr = usrsTmp[i] as Usr;
            usrsTmp.push(usr.copy())
        }

        return usrs;
    }

    copyFrom(usrs: Array<Usr>, usrsTmp: Array<Usr>): void {
        let usrsMap: Map<string, Usr> = new Map<string, Usr>();
        for (let i: number = 0; i < usrs.length; i++) {
            let usr: Usr = usrs[i] as Usr;
            usrsMap.set(this.getPrimaryKey(usr), usr);
        }

        usrs.splice(0, usrs.length);

        for (let i: number = 0; i < usrsTmp.length; i++) {
            let usrTmp: Usr = usrsTmp[i] as Usr;

            let usr: Usr = usrsMap.get(this.getPrimaryKey(usrTmp));
            if (usr) {
                usr.copyFrom(usrTmp);
            } else {
                usr = Usr.parse(usrTmp);
            }

            usrs.push(usr);
        }
    }

    compare(usrs: Array<Usr>, usrsTmp: Array<Usr>) {
        if (usrs.length != usrsTmp.length)
            return 'usrs length mismatch.';

        for (var i: number = 0; i < usrs.length; i++) {
            let usr: Usr = usrs[i] as Usr;
            let usrTmp: Usr = usrsTmp[i] as Usr;

            let diffString: string = usr.compare(usrTmp);
            if (diffString != CommonEnums.defaults.STRING_EMPTY)
                return diffString;
        }

        return '';
    }

    toString(usrs: Array<Usr>) {
        let str: string = '';

        str += 'usr length: ' + usrs.length + ' ';

        for (var i: number = 0; i < usrs.length; i++) {
            let usr: Usr = usrs[i] as Usr;
            str += usr.toString();
        }

        return str;
    }
}